import { useRouter } from 'hooks/useRouter';
import React, { useEffect, useMemo } from 'react';
import { HOME, ROOT_FOLDER } from 'redhotpie-shared-lib/constants/routes';
import { useSelector } from 'redhotpie-shared-lib/hooks/useRedux';
import { getMessengerSetting } from 'redhotpie-shared-lib/selectors/loginSelector';

interface IThemeContext {
  darkMode: boolean;
}

export const ThemeContext = React.createContext<IThemeContext>({
  darkMode: false,
});

const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { location } = useRouter();
  const messengerSetting = useSelector(getMessengerSetting);
  const darkMode = useMemo(() => {
    return (
      location.pathname.includes(`${ROOT_FOLDER}/${HOME}`) &&
      (messengerSetting.theme.darkModeSetting === 'Default'
        ? window.matchMedia('(prefers-color-scheme: dark)').matches
        : messengerSetting.theme.darkModeSetting === 'On')
    );
  }, [messengerSetting, location.pathname]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return <ThemeContext.Provider value={{ darkMode }}>{children}</ThemeContext.Provider>;
};

export default ThemeProvider;
